/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { signal } from "../common/service/signal";

export abstract class CertService extends signal {
   public abstract tryToShowCertPage(url: string);
   public setXHRTimeoutValue() {}
}
